import { render, staticRenderFns } from "./NotificationSideMenu.vue?vue&type=template&id=707861b4"
import script from "./NotificationSideMenu.vue?vue&type=script&lang=ts"
export * from "./NotificationSideMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports